<template>
    <div class="myExamGrades">
        <el-row>
            <el-col :span="24">
                <div class="information">
                    <div class="informationCenter">
                        <div class="informationTitle">
                            <Title text="我的成绩" />
                        </div>
                        <div class="elTabs">
                            <div class="averageScoreClass">平均分: <span v-if="disGeneralDataList&&disGeneralDataList.acg_score">{{disGeneralDataList.acg_score}}</span></div>
                            <div class="informationDiv">
                                <el-table style="width:99%" slot="list" :data="disGeneralDataList.course_data"
                                    headerRowClassName="uni-primary-table-header" stripe border>
                                    <el-table-column prop="start_year" align="center" label="学年"></el-table-column>
                                    <el-table-column prop="course_semester" align="center" label="学期"></el-table-column>
                                    <el-table-column prop="course_title_copy" align="center" label="课程">
                                    </el-table-column>
                                    <el-table-column prop="score" align="center" label="最终成绩"></el-table-column>

                                </el-table>
                            </div>

                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { myStudentScore, courseReview } from "@/api/basic";
import { downLoadFiles } from "@/utils/func";
export default {
    name: "myExamGrades",
    data() {
        return {
            activeName: "examination",
            dataList: [],
            disGeneralDataList: [],
            // exam_status: [
            //     "-",
            //     "报名待审核",
            //     "缴费审核失败",
            //     "待考试",
            //     "阅卷中",
            //     "缺考",
            //     "考试完成",
            // ],
        };
    },
    mounted() {
        this.getDisGeneralData();
    },
    methods: {
        // 非统考成绩
        async getDisGeneralData() {
            const { result } = await myStudentScore();
            if (result) {
                this.disGeneralDataList = result;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.information {
    min-height: $contentH;
    padding: 20px 20px 0 20px;
    /deep/ .el-table .cell {
        padding: 5px 0;
    }
}
.informationCenter {
    width: 100%;
    min-height: inherit;
    background-color: #fff;
}
.informationTitle {
    display: flex;
    align-items: center;
}
.elTabs {
    padding: 0 20px;
}
.informationTitle span {
    display: inline-block;
    width: 4px;
    height: 23px;
    background-color: #1459a6;
}
.informationTitle {
    padding-left: 20px;
}
.informationDiv {
    width: 100%;
    margin-top: 28px;
}

.link-btn {
    height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.averageScoreClass{
   width: 100%;
   text-align: right;
   padding-right: 50px;
}
</style>
